import React from 'react';
import PropTypes from 'prop-types';

const styles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
};

const OidcError = ({ title, message }) => {
    return (
        <div className="oidc-error" style={styles}>
            <h2 className="oidc-error__title">{title}</h2>
            <p className="oidc-error__message">{message}</p>
        </div>
    );
};

OidcError.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};

export default OidcError;
